import React from "react";

import "./DirectoryAvatar.css";

type Props = {
  name: string;
  photoUrl?: string | null;
  className?: string;
};

function initialsFromName(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

export const DirectoryAvatar: React.FC<Props> = ({ name, photoUrl, className = "" }) => {
  const initials = initialsFromName(name) || "?";
  if (photoUrl) {
    return <img className={`directory-avatar directory-avatar--photo${className ? ` ${className}` : ""}`} src={photoUrl} alt="" />;
  }
  return (
    <div className={`directory-avatar${className ? ` ${className}` : ""}`} aria-hidden="true">
      {initials}
    </div>
  );
};
